<div layout="row" layout-margin>
    <div flex="30" flex-sm="100">
        <form *ngIf="dataAvailable === true" [formGroup]="formAds" (submit)="submitForm()" method="post">
            <div style="margin: 20px">
                <h1>Anúncios</h1>
                <div class="row">
                    <div>
                        <mat-form-field>
                            <mat-label>Descrição</mat-label>
                            <input formControlName=nome matInput>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field>
                            <mat-label>youtube.com/watch?v=</mat-label>
                            <input formControlName=url matInput>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field>
                            <mat-label>Status</mat-label>
                            <mat-select required style="height: 20px !important;" formControlName=status>
                                <mat-option value="ativo">Ativo</mat-option>
                                <mat-option value="inativo">Inativo</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-8 mx-auto mt-5">
                <div style="margin: 30px">
                    <button [disabled]="showSpinner ? true : false" class="mt-3" type="submit" mat-raised-button
                        color="primary">
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                        </mat-spinner>Atualizar
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>